// extracted by mini-css-extract-plugin
export default {"bodyCard":"AllEntregasCardSt_bodyCard__m6HlU","contentVideo":"AllEntregasCardSt_contentVideo__hKkdR","contentText":"AllEntregasCardSt_contentText__mDS9d"};